<div class="form-group-block">
    <div class="form-group">
        <label>Dateiname</label>
        <input type="text" [(ngModel)]="fileName" class="form-control" placeholder="Geben Sie den Dateinamen ein" aria-describedby="fileNameHelpBlock" />
        <small id="fileNameHelpBlock" class="form-text text-muted">
            Bitte verwenden Sie keine Angaben des Dateiformats, wie z.B. .doc
        </small>
    </div>
    <div class="form-group">
        <label>Type</label>
        <div>
            <input type="radio" [(ngModel)]="secretType" value="encrypted" /> Verschlüsseln (empfohlen)
        </div>
        <div>
            <input type="radio" [(ngModel)]="secretType" value="cleartext" /> Unverschlüsselt
        </div>
    </div>
    <div class="form-group" *ngIf="secretType==='encrypted'">
        <label>Passwort</label>
        <input type="text" [(ngModel)]="secretKey" class="form-control" placeholder="Passwort wählen" aria-describedby="secretKeyHelpBlock" />
        <small id="secretKeyHelpBlock" class="form-text text-muted">
            Wenn Sie kein Passwort wählen wird die Datei automatisch verschlüsselt.
        </small>
    </div>
</div>
